export type UpdateComponentProjectsRequest = {
  cpntPjtList: UpdateCpntPjtList[];
};
export type UpdateCpntPjtList = {
  index: number;
  pjtId: string;
  pjtSts: string;
  stgOnlyFlg: string;
  othrStgStupFlg: string;
  stgDplymntPlnDate: string;
  prdDplymntPlnDate: string;
  stgIfdDplymntPsblFlg: string;
  prdIfdDplymntPsblFlg: string;
  updateDateTime: string;
};
